import { useMemo } from 'react';
import { useCustomerCardContext } from '../../CustomerFormContext';
import EmploymentFields from './EmploymentFields';
import CustomerFieldsLayoutHeader from './CustomerFieldsLayoutHeader';
import { DEFAULT_ERROR_STATE, type ErrorState } from '@makemydeal/dr-dash-ui-utils';

export const CurrentEmployment = () => {
    const { formValues, formErrors, handleInputChange, handleNumberInputChange, isLocked } = useCustomerCardContext();

    const currentEmp = formValues.currentEmployment;
    const currentEmpErrors = formErrors?.currentEmployment as Record<string, ErrorState> | undefined;
    const finInfo = formValues.financialInfo;
    const finErrors = formErrors?.financialInfo as Record<string, ErrorState> | undefined;

    const employmentValues = useMemo(
        () => ({
            status: currentEmp?.status,
            employerName: currentEmp?.employerName,
            occupation: currentEmp?.occupation,
            workPhone: currentEmp?.workPhone,
            totalYearsEmployed: currentEmp?.totalYearsEmployed,
            totalMonthsEmployed: currentEmp?.totalMonthsEmployed,
            address: currentEmp?.address
        }),
        [currentEmp]
    );

    const employmentErrors = useMemo(
        () => ({
            status: currentEmpErrors?.status || DEFAULT_ERROR_STATE,
            employerName: currentEmpErrors?.employerName || DEFAULT_ERROR_STATE,
            occupation: currentEmpErrors?.occupation || DEFAULT_ERROR_STATE,
            workPhone: currentEmpErrors?.workPhone || DEFAULT_ERROR_STATE,
            totalYearsEmployed: currentEmpErrors?.totalYearsEmployed || DEFAULT_ERROR_STATE,
            totalMonthsEmployed: currentEmpErrors?.totalMonthsEmployed || DEFAULT_ERROR_STATE,
            address: currentEmpErrors?.address as
                | { streetAddress?: ErrorState; city?: ErrorState; state?: ErrorState; zip?: ErrorState }
                | undefined
        }),
        [currentEmpErrors]
    );

    const financialValues = useMemo(
        () => ({
            income: finInfo?.income,
            incomeFrequency: finInfo?.incomeFrequency
        }),
        [finInfo]
    );

    const financialErrors = useMemo(
        () => ({
            income: finErrors?.income || DEFAULT_ERROR_STATE,
            incomeFrequency: finErrors?.incomeFrequency || DEFAULT_ERROR_STATE
        }),
        [finErrors]
    );

    return (
        <div data-testid="current-employment-section">
            <CustomerFieldsLayoutHeader>Current Employment</CustomerFieldsLayoutHeader>
            <EmploymentFields
                type="current"
                values={employmentValues}
                errors={employmentErrors}
                financialValues={financialValues}
                financialErrors={financialErrors}
                handleInputChange={handleInputChange}
                handleNumberInputChange={handleNumberInputChange}
                disabled={isLocked}
            />
        </div>
    );
};

export default CurrentEmployment;
